/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ConfirmTicketRequest,
    ConfirmTicketResponse,
} from '../models';

export interface DConTicketApiControllerConfirmTicketRequest {
    confirmTicketRequest: ConfirmTicketRequest;
}

/**
 * 
 */
export class DCon2021Api extends runtime.BaseAPI {

    /**
     */
    async dConTicketApiControllerConfirmTicketRaw(requestParameters: DConTicketApiControllerConfirmTicketRequest): Promise<runtime.ApiResponse<ConfirmTicketResponse>> {
        if (requestParameters.confirmTicketRequest === null || requestParameters.confirmTicketRequest === undefined) {
            throw new runtime.RequiredError('confirmTicketRequest','Required parameter requestParameters.confirmTicketRequest was null or undefined when calling dConTicketApiControllerConfirmTicket.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/dcon2021/external_ticket_confirmation`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.confirmTicketRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async dConTicketApiControllerConfirmTicket(requestParameters: DConTicketApiControllerConfirmTicketRequest): Promise<ConfirmTicketResponse> {
        const response = await this.dConTicketApiControllerConfirmTicketRaw(requestParameters);
        return await response.value();
    }

}
